interface ProgressCircleProps {
	size?: 'normal' | 'large'
}

export const ProgressCircle = ({ size = 'normal' }: ProgressCircleProps) => {
	const isLarge = size === 'large'
	const circleSize = isLarge ? '60px' : '40px'
	const borderWidth = isLarge ? '6px' : '4px'

	return (
		<div className="progress-circle">
			<div className="circle-container">
				<div className="circle" style={{
					width: circleSize,
					height: circleSize,
					border: `${borderWidth} solid #f3f3f3`,
					borderTop: `${borderWidth} solid #3498db`,
				}}></div>
			</div>
			<style>
				{`
					.circle-container {
						display: flex;
						justify-content: center;
						align-items: center;
						margin: 20px 0;
					}

					.circle {
						border-radius: 50%;
						animation: spin 1s linear infinite;
					}

					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
				`}
			</style>
		</div>
	)
};